/**
 * Function to be used for interpolating values within bounds. May throw if value is not handled by
 * bounds
 */
export let Consciousness;

(function (Consciousness) {
  Consciousness["Alert"] = "alert";
  Consciousness["Confusion"] = "confusion";
  Consciousness["Verbal"] = "verbal";
  Consciousness["Pain"] = "pain";
  Consciousness["Unresponsive"] = "unresponsive";
})(Consciousness || (Consciousness = {}));

export let OxygenSaturationScale;
/**
 * Clinical risk levels as defined by NEWS2. These values are defined by `ClinicalRiskBounds`
 */

(function (OxygenSaturationScale) {
  OxygenSaturationScale["Scale1"] = "scale-1";
  OxygenSaturationScale["Scale2Air"] = "scale-2-air";
  OxygenSaturationScale["Scale2Oxygen"] = "scale-2-oxygen";
})(OxygenSaturationScale || (OxygenSaturationScale = {}));

export let NEWS2ClinicalRisk;

(function (NEWS2ClinicalRisk) {
  NEWS2ClinicalRisk["Low"] = "low";
  NEWS2ClinicalRisk["LowMedium"] = "low-medium";
  NEWS2ClinicalRisk["Medium"] = "medium";
  NEWS2ClinicalRisk["High"] = "high";
})(NEWS2ClinicalRisk || (NEWS2ClinicalRisk = {}));
//# sourceMappingURL=types.js.map